module.exports = __webpack_public_path__ + "assets/img/ph_base_sm.9477ee4c.svg";